import styles from "./Footer.module.css";

function Footer() {
    return (
        <footer className={styles.footer}>
            <section id={styles.quadrado}>
                <div id={styles.quadredoUm}>
                    <img src="/images/Header/tooth.webp" alt="Dra Isabel" />
                    <h1>SEM DOR ODONTOLOGIA</h1>
                </div>
                <div id={styles.quadredoDois}>
                    <h3>Desenvolvido por <a href="https://github.com/thribe1ro" target="_blank" rel="noopener noreferrer">Thiago Ribeiro</a></h3>
                </div>
                </section>
        </footer>
    )
}

export default Footer;